<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M13.0332 0.5V4.3288H8.80296V15.2118H4.83034V4.3288H0.5V0.5H13.0332ZM17.711 5.69336C21.1819 5.69336 23.4997 8.07303 23.4997 10.9815L23.4977 10.8842L23.4959 11.0209C23.3937 14.1868 21.209 16.2867 17.9513 16.3849L17.711 16.3885H16.4914V20.5002H11.9805V5.69336H17.711ZM16.4922 8.93632C19.0605 8.76316 20.3447 9.46581 20.3447 11.0443C20.3447 13.6527 16.4922 13.1408 16.4922 13.1408V8.93632Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgNYSSCPA',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>